import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18508deb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Bridge" }
const _hoisted_2 = { class: "Bridge-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Bridge-imgAspect" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "Bridge-form" }
const _hoisted_7 = { class: "Bridge-switcherTitle" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "Bridge-switcherAnno"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "Bridge-switcherTitle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "Bridge-switcherAnno"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "Bridge-bridgeWrapper" }
const _hoisted_18 = {
  key: 1,
  class: "Bridge-bridgeLoader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_BridgeProcessor = _resolveComponent("BridgeProcessor")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_WalletsPopup = _resolveComponent("WalletsPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      "is-testnet": _ctx.isTestnet,
      "show-menu": _ctx.isEthereumWalletConnected && _ctx.walletsPopupState === 'closed',
      ethereumProvider: _ctx.ethereumProvider,
      "disable-disconnect": _ctx.isTransferInProgress,
      onConnectEthereumWalletClick: _ctx.onHeaderConnectEthereumWalletClick
    }, null, 8, ["is-testnet", "show-menu", "ethereumProvider", "disable-disconnect", "onConnectEthereumWalletClick"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("main", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["Bridge-img", { isFromTon: _ctx.isFromTon }])
        }, _hoisted_5, 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["Bridge-switchers", { isFromTon: _ctx.isFromTon }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["Bridge-switcher", { disabled: _ctx.isPairsBlocked }])
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`networks.ton.${_ctx.netTypeName}.nameSwitcher`)), 1),
                  _hoisted_8
                ]),
                _createElementVNode("ul", {
                  class: _normalizeClass(["Bridge-switcherList", { left: _ctx.isFromTon, right: !_ctx.isFromTon }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromPairs, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: item }, [
                      _createElementVNode("button", {
                        disabled: index === 0,
                        onClick: ($event: any) => (_ctx.onPairClick(true, item))
                      }, _toDisplayString(_ctx.$t(`networks.${item}.${_ctx.netTypeName}.name`)), 9, _hoisted_9)
                    ]))
                  }), 128))
                ], 2)
              ]),
              (_ctx.token === 'ton')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t(`networks.ton.${_ctx.netTypeName}.coin`)), 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("button", {
              class: "Bridge-switcher-arrow",
              disabled: _ctx.isPairsBlocked,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFromTon && _ctx.toggleFromTon(...args)))
            }, null, 8, _hoisted_11),
            _createElementVNode("div", {
              class: _normalizeClass(["Bridge-switcher", { disabled: _ctx.isPairsBlocked }])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`networks.${_ctx.pair}.${_ctx.netTypeName}.nameSwitcher`)), 1),
                  _hoisted_13
                ]),
                _createElementVNode("ul", {
                  class: _normalizeClass(["Bridge-switcherList", { left: !_ctx.isFromTon, right: _ctx.isFromTon }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toPairs, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("button", {
                        disabled: index === 0,
                        onClick: ($event: any) => (
                        _ctx.onPairClick(
                          item === 'ton',
                          item === 'ton' ? _ctx.pair : item
                        )
                      )
                      }, _toDisplayString(_ctx.$t(`networks.${item}.${_ctx.netTypeName}.name`)), 9, _hoisted_14)
                    ]))
                  }), 128))
                ], 2)
              ]),
              (_ctx.token === 'ton')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("a", {
                      href: _ctx.pairNetworkCoinUrl,
                      target: "_blank"
                    }, _toDisplayString(_ctx.$t(`networks.${_ctx.pair}.${_ctx.netTypeName}.coin`)), 9, _hoisted_16)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2),
          _createVNode(_component_CustomInput, {
            key: "token",
            disabled: _ctx.isInputsBlocked || this.pair === 'bsc',
            label: _ctx.$t('sendToken'),
            type: "text",
            dropdown: [
              { label: 'Toncoin', value: 'ton' },
              { label: 'USDC', value: 'usdc' },
              { label: 'DAI', value: 'dai' },
              { label: 'WBTC', value: 'wbtc' },
              { label: 'jUSDT', value: 'usdt' },
              { label: _ctx.$t('otherTokens'), value: 'otherTokens' },
            ],
            modelValue: _ctx.token,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.token) = $event))
          }, null, 8, ["disabled", "label", "dropdown", "modelValue"]),
          (_ctx.token === 'otherTokens')
            ? (_openBlock(), _createBlock(_component_CustomInput, {
                key: "tokenAddress",
                disabled: _ctx.isInputsBlocked,
                label: _ctx.$t('tokenAddress', {network: _ctx.isFromTon ? 'TON' : _ctx.pair.toUpperCase()}),
                type: "text",
                error: _ctx.errors.tokenAddress,
                onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.tokenAddress = '')),
                onBlur: _ctx.checkInputs,
                modelValue: _ctx.tokenAddress,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tokenAddress) = $event))
              }, null, 8, ["disabled", "label", "error", "onBlur", "modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_CustomInput, {
            key: "amountInput",
            disabled: _ctx.isInputsBlocked,
            label: _ctx.$t('amountOfTon', {tokenSymbol: _ctx.tokenSymbol}),
            type: "text",
            error: _ctx.errors.amount,
            onChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.amount = '')),
            onBlur: _ctx.checkInputs,
            modelValue: _ctx.amountInput,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.amountInput) = $event))
          }, null, 8, ["disabled", "label", "error", "onBlur", "modelValue"]),
          _createVNode(_component_CustomInput, {
            key: "toAddress",
            disabled: _ctx.isInputsBlocked,
            label: _ctx.$t(`addressInputLabel`, {network: _ctx.isFromTon ? _ctx.pair.toUpperCase() : 'TON'}),
            type: "text",
            error: _ctx.errors.toAddress,
            onChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.errors.toAddress = '')),
            onBlur: _ctx.checkInputs,
            modelValue: _ctx.toAddress,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.toAddress) = $event))
          }, null, 8, ["disabled", "label", "error", "onBlur", "modelValue"]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["Bridge-willReceive", { isFromTon: _ctx.isFromTon }])
          }, _toDisplayString(_ctx.willReceive), 3), [
            [_vShow, !_ctx.isTransferInProgress && _ctx.willReceive]
          ]),
          _createElementVNode("div", _hoisted_17, [
            (!_ctx.isEthereumWalletConnected)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "Bridge-connect",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.walletsPopupState = 'opened'))
                }, _toDisplayString(_ctx.$t("connectWallet")), 1))
              : _createCommentVNode("", true),
            (_ctx.isEthereumWalletConnected && _ctx.bridgeProcessorIsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.isEthereumWalletConnected)
              ? (_openBlock(), _createBlock(_component_BridgeProcessor, {
                  ref: "bridgeProcessor",
                  key: _ctx.pair,
                  "is-testnet": _ctx.isTestnet,
                  "is-recover": _ctx.isRecover,
                  lt: _ctx.lt,
                  hash: _ctx.hash,
                  "evm-hash": _ctx.evmHash,
                  "is-from-ton": _ctx.isFromTon,
                  pair: _ctx.pair,
                  tokenAddress: _ctx.getTokenAddress,
                  amount: _ctx.amountInput.trim(),
                  "to-address": _ctx.toAddress,
                  tokenSymbol: _ctx.tokenSymbol,
                  ethereumProvider: _ctx.ethereumProvider,
                  tonConnect: _ctx.tonConnect,
                  token: _ctx.token,
                  "is-inputs-valid": _ctx.isInputsValid,
                  onTransferInProgress: _ctx.onTransferInProgress,
                  onStateChanged: _ctx.getPairGasFee__debounced,
                  onResetState: _ctx.resetState,
                  onSaveState: _ctx.saveState,
                  onDeleteState: _ctx.deleteState,
                  onReady: _ctx.onBridgeProcessorReady,
                  onError: _ctx.onBridgeTransferError
                }, null, 8, ["is-testnet", "is-recover", "lt", "hash", "evm-hash", "is-from-ton", "pair", "tokenAddress", "amount", "to-address", "tokenSymbol", "ethereumProvider", "tonConnect", "token", "is-inputs-valid", "onTransferInProgress", "onStateChanged", "onResetState", "onSaveState", "onDeleteState", "onReady", "onError"]))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("div", { class: "Bridge-pairFee" }, _toDisplayString(_ctx.pairFee), 513), [
            [_vShow, !_ctx.isTransferInProgress]
          ]),
          _withDirectives(_createElementVNode("div", { class: "Bridge-bridgeFee" }, _toDisplayString(_ctx.bridgeFee), 513), [
            [_vShow, !_ctx.isTransferInProgress]
          ])
        ])
      ]),
      _createVNode(_component_Footer)
    ]),
    (_ctx.walletsPopupState !== 'closed')
      ? (_openBlock(), _createBlock(_component_WalletsPopup, {
          key: 0,
          params: _ctx.params,
          uncancellable: _ctx.walletsPopupState === 'opened-uncancellable',
          onWalletConnected: _ctx.onWalletConnected,
          onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.walletsPopupState = 'closed'))
        }, null, 8, ["params", "uncancellable", "onWalletConnected"]))
      : _createCommentVNode("", true)
  ]))
}